'use strict';

global.config = typeof window !== 'undefined' ? window.appConfig : context.appContext.config;

export default class Mix {
    static img(path) {
        if (!path) {
            return '';
        }

        const subdomain = global.config.imgSubdomain || '';

        if (path[0] !== '/') {
            path = '/' + path;
        }

        return subdomain + path;
    }

    static asset(path) {
        if (!path) {
            return '';
        }

        const subdomain = global.config.staticSubdomain || '';

        if (path[0] !== '/') {
            path = '/' + path;
        }

        return subdomain + path;
    }

    static loadCSS(path) {
        if (!path) {
            return '';
        }

        path = Mix.asset(path);

        if (document.querySelector(`link[href="${path}"][rel="stylesheet"]`)) {
            return;
        }

        const link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', path);

        document.head.appendChild(link);
    }
}
